// extracted by mini-css-extract-plugin
export var close = "Term-module--close--29681";
export var container = "Term-module--container--10885";
export var content = "Term-module--content--74915";
export var description = "Term-module--description--ea46c";
export var header = "Term-module--header--cb09f";
export var title = "Term-module--title--ef041";